import { baseEnvironment, buildEnvironment } from './environment.interface';

export const environment = buildEnvironment(baseEnvironment, {
	configuration: 'demo',
	baseUrl: 'https://demo.klifdweb.de/',
	auth: {
		scopes: ['api://135398e0-c22e-4c08-b3c9-54095c400f54/Sample.Req'],
		clientId: '135398e0-c22e-4c08-b3c9-54095c400f54',
		authority: 'https://demoklifdweb.ciamlogin.com/c5d6e84a-0bac-4bce-95f8-17236ef7052f/v2.0',
		knownAuthorities: ['demoklifdweb.ciamlogin.com'],
		redirectUri: '/',
		postLogoutRedirectUri: '/',
	},
	appInsightsConnectionString:
		'InstrumentationKey=b5a3a855-6228-4e31-adc9-5da1d778e956;IngestionEndpoint=https://germanywestcentral-1.in.applicationinsights.azure.com/;LiveEndpoint=https://germanywestcentral.livediagnostics.monitor.azure.com/;ApplicationId=19606e4f-8d40-4ad8-a8c0-e675e1c8cfaa',
	showDevTools: false,
});
